import React, { useState } from "react";
import "../../styles/Investers.css";
import PersonelDetails from "../../components/Admin/PersonalDetails"
import BankDetails from "../../components/Admin/BankDetails"
import FatchDeclaration from "../../components/Admin/FatchDeclaration"
import ManageNominess from "../../components/Admin/ManageNominess"
import { IoMdClose } from "react-icons/io";
import { FaCircleCheck } from "react-icons/fa6";
const EditInvestor = () => {
    const [currentStep, setCurrentStep] = useState(1); // State to track the current step
    const totalSteps = 4; // Total number of steps
    const [isModalOpen, setIsModalOpen] = useState(false);

    const closeModal = () => {
        setIsModalOpen(false);
    };

    // Modal open handler
    const openModal = () => {
        setIsModalOpen(true);
    };

    const handleDelete = () => {
        closeModal();
    };

    // Function to handle the "Next" button
    const handleNext = () => {
        if (currentStep < totalSteps) {
            setCurrentStep(currentStep + 1);
        }
    };

    // Function to handle the "Back" button
    const handleBack = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    // Function to get the step heading based on the current step
    const getStepHeading = (step) => {
        switch (step) {
            case 1:
                return (
                    <div>
                        <p className="step-heading">Step 1 of 4</p>
                        <p className="step-label">Personal Details</p>
                    </div>
                );
            case 2:
                return (
                    <div>
                        <p className="step-heading">Step 2 of 4</p>
                        <p className="step-label">Bank Details</p>
                    </div>
                );
            case 3:
                return (
                    <div>
                        <p className="step-heading">Step 3 of 4</p>
                        <p className="step-label">FATCA Declaration</p>
                    </div>
                );
            case 4:
                return (
                    <div>
                        <p className="step-heading">Step 4 of 4</p>
                        <p className="step-label">Manage Nominees</p>
                    </div>
                );
            default:
                return "";
        }
    };

    // Function to render the content for each step
    const renderStepContent = (step) => {
        switch (step) {
            case 1:
                return <div>
                    <PersonelDetails />
                </div>;
            case 2:
                return <div><BankDetails /></div>;
            case 3:
                return <div>
                    {/* FATCA Declaration Form */}
                    <FatchDeclaration />
                </div>;
            case 4:
                return <div>
                    {/* Manage Nominees Form */}
                    <ManageNominess />
                </div>;
            default:
                return null;
        }
    };

    return (
        <div className="container-fluid page_background">
            <div className="page-inner-content mb-3">
                <div className="page_inner_content_box">
                    {/* Main Heading */}
                    <h5 className="mb-4 main-heading-title">Edit Investor Details</h5>
                    {/* Dynamic Step Heading */}
                    <p
                    // className="step-info"
                    >{getStepHeading(currentStep)}</p>

                    {/* Progress Bar */}
                    <div className="mb-4">
                        <div className="progress" style={{ height: "5px" }}>
                            <div
                                className="progress-bar"
                                role="progressbar"
                                style={{ width: `${(currentStep / totalSteps) * 100}%` }}
                                aria-valuenow={(currentStep / totalSteps) * 100}
                                aria-valuemin={0}
                                aria-valuemax={100}
                            ></div>
                        </div>
                    </div>

                    {/* Card Content */}
                    <div className="card redeam_bottom_card border-top-rounded">
                        {renderStepContent(currentStep)}
                    </div>

                    {/* Navigation Buttons */}
                    <div className="card-footer form_card form_card_border">
                        <div className="d-flex justify-content-between gap-2">
                            {currentStep > 1 && (
                                <button
                                    type="button"
                                    onClick={handleBack}
                                    className="form_button"
                                >
                                    Back
                                </button>
                            )}
                            {currentStep < totalSteps ? (
                                <button
                                    type="button"
                                    onClick={handleNext}
                                    // className="form_button next_btn"
                                    className={`form_button next_btn ${currentStep === 1 ? "next-btn-right" : ""}`}

                                >
                                    Next
                                </button>
                            ) : (
                                <button
                                    type="submit"
                                    className="form_button next_btn"
                                    onClick={openModal}
                                >
                                    Save
                                </button>
                            )}
                        </div>


                        {isModalOpen && (

                            <div className="modal show">

                                <div className="invester-popup">
                                    <div className="modal-header invester-modal-header">
                                        <h5 className="modal-title"></h5>

                                        <IoMdClose onClick={closeModal} className="close-popup-color" style={{ margin: "10px" }} />

                                    </div>

                                    <div className="modal-body invester-modal-body">

                                        <FaCircleCheck fontSize="large" className="invester-modal-icon" />

                                        <p>Investor details updated <br /> successfully!</p>
                                    </div>

                                    <div className="invester-modal-footer">

                                        <button type="button" className="btn btn-primary" onClick={handleDelete}>Ok</button>
                                    </div>
                                </div>

                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditInvestor;
